export default "__VITE_ASSET__ca22fd7c__"